<template>
    <div>
        <section class="container-fluid bg-alt" style="background-color:white !important;">
            <div class="container">
                <div class="row">
                    <div class="col ways3">
                        <h2>Powering a brighter future for our customers</h2>
                        <div class="linebreak"></div>
                        <p>Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis</p>
                    </div>
                </div>
                <div class="card-deck mb-3 text-center">
                <div class="card mb-4">
                    <div class="card-header">
                    <img src="@/assets/icons/003-user.svg" class="points" alt="">
                    <h4><span>85</span> million</h4>
                    </div>
                    <div class="card-body">
                    <p>Happy users</p>
                    </div>
                </div>
                <div class="card mb-4">
                    <div class="card-header">
                    <img src="@/assets/icons/001-invoice.svg" class="points" alt="">
                    <h4><span>25</span> million</h4>
                    </div>
                    <div class="card-body">
                    <p>quotation sent</p>
                    </div>
                </div>
                <div class="card mb-4">
                    <div class="card-header">
                    <img src="@/assets/icons/002-ship.svg" class="points" alt="">
                    <h4><span>85</span> million</h4>
                    </div>
                    <div class="card-body">
                    <p>Successful shipping</p>
                    </div>
                </div>
                </div>
            </div>
        </section>

        <section class="container-fluid platform alt">
            <div class="row">
                <div class="col col-platform">
                <h3>Complete control & visibility</h3>
                <div class="linebreak"></div>
                <p>Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis 
                    natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.</p>
                </div>
                <div class="col-7 screenshot shadow-lg"><img src="@/assets/whyus/price.png" alt=""></div>
            </div>
        </section>

        <section class="container-fluid platform">
            <div class="row">
                <div class="col col-platform">
                <h3>Transparent pricing</h3>
                <div class="linebreak"></div>
                <p>Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis 
                    natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.</p>
                </div>
                <div class="col-7 screenshot shadow-lg"><img src="@/assets/whyus/details.png" alt=""></div>
            </div>
        </section>

        <section class="container-fluid platform alt">
            <div class="row">
                <div class="col col-platform">
                <h3>Real-time freight visibility</h3>
                <div class="linebreak"></div>
                <p>Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis 
                    natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.</p>
                </div>
                <div class="col-7 screenshot shadow-lg"><img src="@/assets/whyus/quotation.png" alt=""></div>
            </div>
        </section>
    </div>
</template>

<script>
export default {

}
</script>

<style>

</style>
